<template>
    <div>
        <component v-if="componentName" :is="componentName" :type="type" :originData="originData" :logisticsType="logisticsType" ref="commonForm"></component>
        <!-- 已报关 -->
        <div class="formSubmit" v-if="componentName === 'comDeclare'">
            <vForm class="clearfix" labelWidth="100" v-model="formData">
                <vCol span="12">
                    <vFormItem :label="$t('global.common.notes', { defaultValue: '备注' })">
                        <vTextarea v-model="formData.remark"></vTextarea>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem labelWidth="100" :label="$t('fbb.headlogistics.attach_upload', { defaultValue: '附件上传' })">
                        <div class="upload">
                            <div class="upload-item" v-for="(item, index) in formData.attachments" :key="item.key">
                                <div class="filename">{{item.fileName}}</div>
                                <div><Icon class="close" size="13" type="md-close" @click="clearUpload(index)" /></div>
                            </div>
                        </div>
                        <vButton theme="success" @click="importFile">{{$t('global.common.add', { defaultValue: '添加' })}}</vButton>
                    </vFormItem>
                </vCol>
                <div class="pull-right">
                    <vButton style="margin: 10px 5px;" theme="primary" :disabled="isSubmit" @click="submit">{{$t('global.common.confirm', { defaultValue: '确定' })}}</vButton>
                    <vButton style="margin: 10px 5px;" @click="cancel">{{$t('global.common.operate_cancel', { defaultValue: '取消' })}}</vButton>
                </div>
            </vForm>
        </div>
        <div class="formSubmit" v-else>
            <vForm class="clearfix" labelWidth="150" ref="subForm" v-model="formData">
                <!-- 已清关 -->
                <div v-if="type === 'clearCustoms'">
                    <vCol span="24">
                        <vFormItem :label="$t('fbb.headlogistics.customer_clearance_date', { defaultValue: '清关日期' })" class="width-75per" prop="extra_clear_date" :rules="required">
                            <vDatepicker type="date" v-model="formData.content.extra_clear_date"></vDatepicker>
                        </vFormItem>
                    </vCol>
                </div>
                <!--税号-->
                <div v-if="type === 'clearCustoms'">
                    <vCol span="24">
                        <vFormItem :label="$t('fbb.headlogistics.customer_tax_no', { defaultValue: '税号' })" class="width-75per" prop="extra_clear_date" :rules="required">
                            <vInput v-model="formData.content.extra_tax_number"></vInput>
                        </vFormItem>
                    </vCol>
                </div>
                <!-- 已到港 -->
                <div v-else-if="type === 'reachPort'">
                    <vCol span="24">
                        <vFormItem :label="$t('fbb.headlogistics.arrival_at', { defaultValue: '到港日期' })" class="width-75per" prop="extra_arrive_date" :rules="required">
                            <vDatepicker type="date" v-model="formData.content.extra_arrive_date"></vDatepicker>
                        </vFormItem>
                    </vCol>
                </div>
                <!-- 上传发票 -->
                <div v-else-if="type === 'uploadBill'">
                    <vCol span="24">
                        <vFormItem :label="$t('fbb.headlogistics.shangchuanfapiao', { defaultValue: '上传发票' })" class="width-75per" prop="invoice_src" :rules="required">
                            <div class="upload" v-if="formData.content.invoice_src">
                                <div class="upload-item">
                                    <div class="filename">{{formData.content.invoice_src}}</div>
                                    <div><Icon class="close" size="13" type="md-close" @click="clearUpload" /></div>
                                </div>
                            </div>
                            <vButton theme="success" v-else @click="importFile(type)">{{$t('global.common.add', { defaultValue: '添加' })}}添加</vButton>
                            <vInput class="hidden-input" hidden v-model="formData.content.invoice_src"></vInput>
                        </vFormItem>
                    </vCol>
                </div>
                
                <!-- 上传POD -->
                <div v-else-if="type === 'uploadPOD'">
                    <vCol span="24">
                        <vFormItem label="上传POD" class="width-75per" prop="pod_src" :rules="required">
                            <div class="upload" v-if="formData.content.pod_src">
                                <div class="upload-item">
                                    <div class="filename">{{formData.content.pod_src}}</div>
                                    <div><Icon class="close" size="13" type="md-close" @click="clearUpload" /></div>
                                </div>
                            </div>
                            <vButton theme="success" v-else @click="importFile(type)">{{$t('global.common.add', { defaultValue: '添加' })}}</vButton>
                            <vInput class="hidden-input" hidden v-model="formData.content.pod_src"></vInput>
                        </vFormItem>
                    </vCol>
                </div>
                <!-- 确认发票 -->
                <div v-else-if="type === 'confirmBill'">
                    <vCol span="24">
                        <vFormItem :label="$t('erp.b2border.invoice', { defaultValue: '发票号' })" class="width-75per" prop="invoice_no" :rules="required">
                            <vInput v-model="formData.content.invoice_no"></vInput>
                        </vFormItem>
                    </vCol>
                    <vCol span="24">
                        <vFormItem :label="$t('fbb.headlogistics.cost_china', { defaultValue: '中国段费用' }) + '(USD)'" class="width-75per" prop="china_cost" :rules="required">
                            <vInputNumber min="0" v-model="formData.content.china_cost" @on-change="changeTotalCost"></vInputNumber>
                        </vFormItem>
                    </vCol>
                    <vCol span="24">
                        <vFormItem :label="$t('fbb.headlogistics.cost_sea', { defaultValue: '海运费' }) + '(USD)'" class="width-75per" prop="ocean_freight" :rules="required">
                            <vInputNumber min="0" v-model="formData.content.ocean_freight" @on-change="changeTotalCost"></vInputNumber>
                        </vFormItem>
                    </vCol>
                    <vCol span="24">
                        <vFormItem :label="$t('fbb.headlogistics.destination_cost', { defaultValue: '目的国费用' }) + '(USD)'" class="width-75per" prop="destination_cost" :rules="required">
                            <vInputNumber min="0" v-model="formData.content.destination_cost" @on-change="changeTotalCost"></vInputNumber>
                        </vFormItem>
                    </vCol>
                    <vCol span="24">
                        <vFormItem :label="$t('fbb.headlogistics.tariff', { defaultValue: '关税' }) + '(USD)'" class="width-75per" prop="tariff" :rules="required">
                            <vInputNumber min="0" v-model="formData.content.tariff" @on-change="changeTotalCost"></vInputNumber>
                        </vFormItem>
                    </vCol>
                    <vCol span="24">
                        <vFormItem :label="$t('fbb.headlogistics.total_cost', { defaultValue: '费用合计' }) + '(USD)'" class="width-75per">
                            <div class="font-weight">{{this.totalCost}}</div>
                        </vFormItem>
                    </vCol>
                    <vCol span="24">
                        <vFormItem :label="$t('fbb.headlogistics.cost_explain', { defaultValue: '费用说明' })" class="width-75per" prop="cost_explain">
                            <vInput v-model="formData.content.cost_explain"></vInput>
                        </vFormItem>
                    </vCol>
                </div>
                <!-- 已预约 -->
                <div v-else-if="type === 'appointment' || type === 'transitAppointment'">
                    <vCol span="24">
                        <vFormItem :label="$t('fbb.headlogistics.appointment_at', { defaultValue: '预约送仓时间' })" class="width-100per" prop="extra_reserve_delivered_date" :rules="required">
                            <vCol span="15.4">
                                <vDatepicker type="date" format="yyyy-mm-dd" v-model="formData.content.extra_reserve_delivered_date"></vDatepicker>
                            </vCol>
                            <vButton theme="primary" style="margin-left: 10px;" @click="goCreateOrder">{{$t('fbb.headlogistics.create_appointment_order', { defaultValue: '创建预约单' })}}</vButton>
                        </vFormItem>
                    </vCol>
                    <!-- 海运拼箱、海运整柜 -->
                    <vCol span="24" v-if="(originData.transportType === 0 || originData.transportType === 6) && ((type === 'appointment' && logisticsType === 'through') || (type === 'transitAppointment' && logisticsType === 'transfer'))">
                        <vFormItem :label="$t('fbb.headlogistics.can_cabinet_date', { defaultValue: '可提柜时间' })" class="width-75per" prop="can_cabinet_date" :rules="required">
                            <!-- <vCol span="15.4"> -->
                                <vDatepicker type="date" format="yyyy-mm-dd" v-model="formData.content.can_cabinet_date"></vDatepicker>
                            <!-- </vCol> -->
                        </vFormItem>
                    </vCol>
                </div>
                <!-- 中转仓到达 -->
                <div v-else-if="type === 'transitArrive'">
                    <vCol span="24">
                        <vFormItem :label="$t('fbb.headlogistics.forwards_stockin_date', { defaultValue: '中转仓到达日期' })" class="width-75per" prop="extra_forwardstockin_date" :rules="required">
                            <vDatepicker type="date" v-model="formData.content.extra_forwardstockin_date"></vDatepicker>
                        </vFormItem>
                    </vCol>
                </div>
                <!-- 已妥投 -->
                <div v-else-if="type === 'delivered'">
                    <vCol span="24">
                        <vFormItem :label="$t('fbb.headlogistics.stock_in', { defaultValue: '妥投日期' })" class="width-75per" prop="extra_stockin_date" :rules="required">
                            <vDatepicker type="date" v-model="formData.content.extra_stockin_date"></vDatepicker>
                        </vFormItem>
                    </vCol>
                </div>
                <!-- 运费录入 -->
                <div v-else-if="type === 'freight'">
                    <vCol span="24">
                        <vFormItem :label="$t('fbb.headlogsitics.carrier_total_cost', { defaultValue: '实际运费' }) + '(USD)'" class="width-75per" prop="extra_other_carrier_total_cost" :rules="required">
                            <vInputNumber min="0" v-model="formData.content.extra_other_carrier_total_cost"></vInputNumber>
                        </vFormItem>
                    </vCol>
                </div>
                <div v-if="type !== 'cancel'">
                    <vCol span="24">
                        <!-- 备注 -->
                        <vFormItem v-if="type === 'remark'" :label="$t('global.common.notes', { defaultValue: '备注' })" class="width-75per" prop="remark" :rules="required">
                            <vTextarea v-model="formData.remark"></vTextarea>
                        </vFormItem>
                        <!-- 恢复正常 -->
                        <vFormItem v-else :label="$t('global.common.notes', { defaultValue: '备注' })" class="width-75per">
                            <vTextarea v-model="formData.remark"></vTextarea>
                        </vFormItem>
                    </vCol>
                    <!-- 上传POD时不需要附件上传 -->
                    <vCol span="24" v-if="type !== 'uploadPOD'">
                        <vFormItem :label="$t('fbb.headlogistics.attach_upload', { defaultValue: '附件上传' })" class="width-75per">
                            <div class="upload">
                                <div class="upload-item" v-for="(item, index) in formData.attachments" :key="item.key">
                                    <div class="filename">{{item.fileName}}</div>
                                    <div><Icon class="close" size="13" type="md-close" @click="clearUpload(index)" /></div>
                                </div>
                            </div>
                            <vButton theme="success" @click="importFile">{{$t('global.common.add', { defaultValue: '添加' })}}</vButton>
                        </vFormItem>
                    </vCol>
                </div>
                <!-- 已取消 -->
                <div v-else>
                    <vCol span="24">
                        <vFormItem :label="$t('fbb.inbound.cancel_reason', { defaultValue: '取消原因' })" class="width-75per" prop="remark" :rules="required">
                            <vTextarea v-model="formData.remark"></vTextarea>
                        </vFormItem>
                    </vCol>
                </div>
                <div class="pull-right">
                    <vButton style="margin: 10px 5px;" theme="primary" :disabled="isSubmit" @click="submit">{{$t('global.common.confirm', { defaultValue: '确定' })}}</vButton>
                    <vButton style="margin: 10px 5px;" @click="cancel">{{$t('global.common.operate_cancel', { defaultValue: '取消' })}}</vButton>
                </div>
            </vForm>
        </div>
        <vModal
            class="hidefooter customerupload"
            v-model="operate.show"
            :title="operate.title"
            v-bind="operate"
        >
            <compUpload
                v-bind="getFileProps"
                @on-success="aaasuccess"
                @on-cancel="cancelUpload"
            />
            <footer slot="footer" v-show="false"></footer>
        </vModal>
    </div>
</template>

<script>
import comBookingSpace from "./comBookingSpace"
import comDeclare from "./comDeclare"
import compExpectWarehouseDate from "./compExpectWarehouseDate.vue"
import { HttpUpdateLogistics } from "@/service/headlogistics"
export default {
    components: {
        compUpload: () => import("@components/templates/upload"),
        comBookingSpace,
        comDeclare,
        compExpectWarehouseDate
    },
    props: ["componentName", "type", "originData", "logisticsType", "isSub", "operateType", "childId"],
    data() {
        return {
            totalCost: 0,
            formData: {
                content: {},
                attachments: []
            },
            required: [
                {
                    required: true,
                    message: this.$t('global.common.information_empty', { defaultValue: "该信息不能为空,请填写" })
                }
            ],
            operate: {
                show: false,
                title: this.$t('fbb.headlogistics.attach_upload', { defaultValue: "附件上传" }),
                data: {}
            },
            isSubmit: false
        };
    },
    computed: {
        getFileProps() {
			return {
				action: process.env.VUE_APP_APIURL_UC + '/api/v1/BizAttach/uploadFile',
				name: "multipartFile",
				data: {
                    srcLabel: this.originData.id,
					model: 'logistics',
                    type: 'other',
				}
			}
		},
    },
    methods: {
        changeTotalCost () {
            this.totalCost = 0
            let keyArr = Object.keys(this.formData.content)
            keyArr.map(item => {
                if (item !== 'total_cost' && item !== 'cost_explain' && item !== 'invoice_no') {
                    this.totalCost = this.totalCost + (this.formData.content[item] ? parseFloat(this.formData.content[item]) : 0)
                }
            })
            this.formData.content.total_cost = parseFloat(this.totalCost.toFixed(2))
            this.totalCost = this.formData.content.total_cost;
        },
        importFile(type) {
            if (type === 'uploadBill') {
                this.operate.type = 'uploadBill'
            }
            else if (type === 'uploadPOD') {
                this.operate.type = 'uploadPOD'
            }
            this.operate.show = true;
        },
        clearUpload (index) {
            this.formData.attachments.splice(index, 1)
        },
        aaasuccess(res) {
            this.cancelUpload()
            this.upload = res.data
            switch (this.operate.type) {
                case 'uploadBill':
                    this.formData.content.invoice_src = res.data.entity.filename
                    this.formData.content.invoice_url = res.data.genUrl
                break
                case 'uploadPOD':
                    this.formData.content.pod_src = res.data.entity.filename
                    this.formData.content.pod_url = res.data.genUrl
                break
                default: {
                    this.formData.attachments.push({
                        fileName: this.upload.entity.filename,
                        fileUrl: this.upload.genUrl
                    })
                }
            }
        },
        cancelUpload() {
            this.operate.show = false;
        },
        goCreateOrder () {
            let routerUrl = this.$router.resolve({
                path: '/home/bespeak/agent/update/add?orgRoleName=FORWARDER'
            })
            window.open(routerUrl.href, '_blank')
        },
        async submit() {
            if (this.isSubmit) return
            let content = {}
            let flag = true
            // 调用了组件
            if (this.$refs.commonForm) {
                await this.$refs.commonForm.checkForm().then(res => {
                    if (!res) {
                        this.$VMessage.error(this.$t('fbb.headlogistics.info_empty', { defaultValue: '请填写必填项' }))
                        flag = false
                    }
                })
                content = this.$refs.commonForm.formData
            }
            // 未调用组件
            else {
                await this.$refs.subForm.validate(valid => {
                    if (!valid) {
                        this.$VMessage.error(this.$t('fbb.headlogistics.info_empty', { defaultValue: '请填写必填项' }))
                        flag = false
                    }
                })
                content = {
                    ...this.formData.content
                }
            }
            
            if (!flag) {
                return
            }

            let requestData = {
                ...this.formData,
                content: content,
                headId: this.isSub ? this.childId: this.originData.id,
                isSub: this.isSub ? true : false,
                type: this.operateType,
            }
            this.isSubmit = true
            await HttpUpdateLogistics(requestData).then(res => {
                this.$VMessage.success(res.message)
                this.success()
            }, err => {
                this.$VMessage.error(err.message)
            })
            this.isSubmit = false
        },
        success () {
            this.$emit("on-close");
            this.$emit('on-success')
        },
        cancel() {
            this.$emit("on-close");
        }
    }
};
</script>

<style lang="scss" scoped>
.hidden-input {
    width: 56px;
    height: 30px;
    position: absolute;
    top: 333px;
    z-index: -1;
}
.upload-item {
    display: flex;
    color: #3399ff;

    .filename {
        width: 100%;
        overflow:hidden;
        white-space:nowrap;
        text-overflow: ellipsis;
    }

    .close {
        margin-left: 5px;
        &:hover {
            color: red;
            cursor: pointer;
        }
    }
}
</style>
